export default __webpack_public_path__ + "static/media/modal-cross-icon.293d4787.svg";